import ResolveMultiSelectField from './ResolveMultiSelectField.component';

export default ResolveMultiSelectField;